export default __webpack_public_path__ + "static/media/grad_gradiska.6710fe0b.png";